module.exports = __webpack_public_path__ + "static/media/bome-logo.5e787fdf.webp";